<template>
    <Layout>
        <Registration />
    </Layout>
</template>

<script>

import Layout from "@/components/layouts/Layout.vue";
import Registration from "../../../components/subpages/Registration.vue";

export default {
    name: "Register",
    components: { Layout, Registration },
}
</script>
